<div class="ion-text-center">
  <ion-text color="primary">
    <h3 class="questions">{{ 'failures-detail-list.Marque todos los problemas' | translate }}</h3>
  </ion-text>
</div>

<ng-container *ngIf="!httpError">
  <ion-searchbar placeholder="{{ 'failures-detail-list.Buscar'  | translate }}" type="text"
    debounce="300" (ionInput)="search($event)">
  </ion-searchbar>

  <cc-skeletons [type]="skeleton"></cc-skeletons>


  <div *ngIf="showLoader" class="ion-text-center">
    <ion-spinner name="lines"></ion-spinner>
  </div>

  <div *ngIf="failureDetails.length">
    <ion-list>
      <ion-item-group (ionChange)="selectDetail($event)">
        <ion-item class="ion-text-wrap" lines="full" *ngFor="let detail of failureDetails; let i = index">
          <ion-checkbox #flawDetails class="check" slot="start" [value]="detail.id" [checked]="detail.checked"
            labelPlacement="end">
            {{ detail.name }}</ion-checkbox>
        </ion-item>
      </ion-item-group>
    </ion-list>

    <ion-infinite-scroll *ngIf="failureDetails.length >= 20" threshold="100px" (ionInfinite)="loadMore($event)">
      <ion-infinite-scroll-content loadingSpinner="bubbles"
        loadingText="{{ 'failures-detail-list.Cargando...'  | translate }}">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>

  <div *ngIf="!failureDetails.length && !skeleton.show && !showLoader" class="centered-content">
    <ion-text large class="no-data" color="medium">
      <br>
      <h1>
        {{ 'failures-detail-list.Sin resultados' | translate }}
      </h1>
    </ion-text>
  </div>

</ng-container>

<cc-http-error *ngIf="httpError" [errorMsg]="httpError" (retry)="ngOnInit()"></cc-http-error>

<div class="ion-padding-top ion-padding-bottom"></div>
